import {
  Shield, Users, Building, UserPlus, DollarSign, UserCheck,
  Layers, CircleUser, ScanFace, CalendarDays, Award, Wallet,
  Receipt, Monitor, BookOpen, LogOut, Network,
  Target, ShieldCheck, Settings, Quote as QuoteIcon, FileText, MapPin, BarChart3,
} from "lucide-react";
import { K } from "../theme";

export const SROLES = [
  { id: "admin",       l: "Super Admin",  ic: Shield,    c: K.r  },
  { id: "hr_head",     l: "HR Head",      ic: Users,     c: K.p  },
  { id: "centre_head", l: "Centre Head",  ic: Building,  c: K.a  },
  { id: "centre_hr",   l: "Centre HR",    ic: MapPin,    c: K.a  },
  { id: "manager",     l: "Manager",      ic: UserCheck, c: K.pu },
  { id: "team_leader", l: "Team Leader",  ic: UserCheck, c: K.pu },
  { id: "team_incharge", l: "Team Incharge", ic: UserCheck, c: K.pu },
  { id: "recruiter",   l: "Recruiter",    ic: UserPlus,  c: K.cy },
  { id: "accounts",    l: "Accounts",     ic: DollarSign,c: K.g  },
  { id: "employee",    l: "Employee",     ic: UserCheck, c: K.bl },
];

// Ordered sidebar groups. `l: ""` renders no header (used for the top item).
// A group with no role-visible items is skipped entirely in the sidebar, so an
// employee never sees an empty "Management" heading.
export const NAV_GROUPS = [
  { id: "main",      l: "" },
  { id: "work",      l: "My Workspace" },
  { id: "finance",   l: "Finance" },
  { id: "resources", l: "Resources" },
  { id: "manage",    l: "Management" },
  { id: "admin",     l: "Admin" },
];

export const NAV = [
  { id: "dashboard",   l: "Dashboard",   ic: Layers,      r: "all", g: "main" },
  { id: "myprofile",   l: "My Profile",  ic: CircleUser,  r: "all", g: "work" },
  { id: "attendance",  l: "Attendance",  ic: ScanFace,    r: "all", g: "work" },
  { id: "leaves",      l: "Leaves",      ic: CalendarDays,r: "all", g: "work" },
  { id: "appraisal",   l: "Appraisal",   ic: Award,       r: "all", g: "work" },
  { id: "payroll",     l: "Payroll",     ic: Wallet,      r: "all", g: "finance" },
  { id: "team_salary", l: "Team Salary", ic: Users,       r: ["admin","hr_head","centre_hr","centre_head","manager","team_leader","team_incharge"], g: "finance" },
  { id: "expenses",    l: "Expenses",    ic: Receipt,     r: "all", g: "finance" },
  { id: "compliance",  l: "Compliance",  ic: ShieldCheck, r: ["admin","accounts"], g: "finance" },
  { id: "assets",      l: "Assets",      ic: Monitor,     r: "all", g: "resources" },
  { id: "documents",   l: "Policies",    ic: BookOpen,    r: "all", g: "resources" },
  // HR Corner: Quotes stays admin/hr_head, but Event Gallery inside it
  // opens up to centre_head (view own centre) and to anyone granted
  // HR Corner → Media Hub in Settings → Permissions. The sidebar tab is visible to that whole set;
  // the internal tab list decides what's editable.
  { id: "hrcorner",    l: "HR Corner",   ic: QuoteIcon,   r: ["admin","hr_head", "centre_hr","centre_head"], g: "resources" },
  { id: "employees",   l: "Employees",   ic: Users,       r: ["admin","hr_head","centre_head","centre_hr","recruiter","accounts"], g: "manage" },
  { id: "org",         l: "Organization",ic: Network,     r: ["admin","hr_head", "centre_hr","centre_head"], g: "manage" },
  { id: "onboarding",  l: "Onboarding",  ic: UserPlus,    r: ["admin","hr_head","recruiter","centre_head","centre_hr"], g: "manage" },
  { id: "separation",  l: "Offboarding",  ic: LogOut,      r: ["admin","hr_head","centre_head","centre_hr","accounts","manager","employee"], g: "manage" },
  { id: "recruitment", l: "Recruitment", ic: Target,      r: ["admin","hr_head","recruiter","centre_head","centre_hr"], g: "manage" },
  { id: "reports",     l: "Reports",     ic: BarChart3,   r: ["admin","hr_head","centre_hr","centre_head","accounts","recruiter"], g: "manage" },
  { id: "templates",   l: "Email/Form Templates", ic: FileText, r: ["admin", "hr_head", "centre_hr"], g: "admin" },
  { id: "settings",    l: "Settings",    ic: Settings,    r: ["admin"], g: "admin" },
];
